import { render, staticRenderFns } from "./MySteps.vue?vue&type=template&id=08cce830&scoped=true&"
import script from "./MySteps.vue?vue&type=script&lang=js&"
export * from "./MySteps.vue?vue&type=script&lang=js&"
import style0 from "./MySteps.vue?vue&type=style&index=0&id=08cce830&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cce830",
  null
  
)

export default component.exports